<template>
  <div class="tab-content-container">
    <!--    Notes    -->
    <div class="tab-header-container">
      <h2 class="form-label">Бележки</h2>
      <LiteButton @click.native="addNote"
                  class="edit-button"
                  :hoverColor="'green'"
                  :icon="'far fa-plus-square'">
      </LiteButton>
    </div>

    <hr class="form-line">

    <!-- One Note -->
    <div class="item-container very-light-shadow"
         style="padding-bottom: 0;"
         v-for="note in notes" :key="note.id">
      <LiteButton @click.native="editNote(note)"
                  class="edit-button"
                  :hoverColor="'blue'"
                  :icon="'far fa-edit'">
      </LiteButton>
      <div class="last-modified-container">
        <p class="last-modified-date" v-text="getLastModifiedDate(note)"></p>
        <p class="last-modified-name" v-text="getLastModifiedBy(note)"></p>
      </div>
      <div class="note-content-container">
        <p class="note-content-label">Съдържание:</p>
        <p class="note-content">{{ note.content }}</p>
      </div>
    </div>

    <!-- Edit/Add Note -->
    <CarNotesEditForm class="popup-shadow" v-if="shouldEdit" :note="currentEditNote" @close-clicked="closeEdit"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import mapperService from "@/services/mapper.service";
import LiteButton from "@/shared/components/button/LiteButton"
import {cloneDeep} from 'lodash';
import CarNotesEditForm from "@/components/car/form/CarNotesEditForm";

export default {
  name: "CarNotes",
  components: {CarNotesEditForm, LiteButton},
  created() {
    this.notes = cloneDeep(this.carNotes);
  },
  data() {
    return {
      carId: this.$route.params.id,
      notes: cloneDeep(this.carNotes),
      shouldEdit: false,
      currentEditNote: null
    }
  },
  methods: {
    getLastModifiedBy(note) {
      return mapperService.getLastModifiedBy(note);
    },
    getLastModifiedDate(note) {
      return mapperService.getLastModifiedDate(note);
    },
    addNote() {
      this.currentEditNote = {};
      this.currentEditNote.carId = this.carId;
      this.$store.commit('setHasModal', true);
      this.shouldEdit = true;
    },
    editNote(note) {
      this.currentEditNote = note;
      this.currentEditNote.carId = this.carId;
      this.$store.commit('setHasModal', true);
      this.shouldEdit = true;
    },
    closeEdit() {
      this.currentEditNote = null;
      this.$store.commit('setHasModal', false);
      this.shouldEdit = false;
    }
  },
  computed: {
    ...mapGetters(['carNotes'])
  },
  watch: {
    carNotes: {
      handler(newVal) {
        if (newVal) {
          this.notes = cloneDeep(newVal);
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
@import '../../../css/main/notes.css';

</style>
